import { atom } from 'jotai'
import { selectAtom } from 'jotai/utils'
import isEqual from 'react-fast-compare'
import type { RestaurantTagId } from '../../../lib/graphql/scalars'
import { foods, scenes } from '../sd/preferences/tags'
import type { TagCategory } from '../sd/preferences/tags'
import { draftSearchCriteria$ } from './draft'
import type { SearchCriteria } from './validate'

export const draftTagIds$ = selectAtom(draftSearchCriteria$, (s) => toTagIds(s), isEqual)

export type Tags = Pick<
  SearchCriteria,
  'sceneTagIds' | 'genreTagIds' | 'drinkTagIds' | 'foodTagIds'
>
export type TagType = keyof Tags

function toTagIds(s: SearchCriteria | undefined) {
  return {
    sceneTagIds: s?.sceneTagIds ?? [],
    foodTagIds: s?.foodTagIds ?? [],
    genreTagIds: s?.genreTagIds ?? [],
    drinkTagIds: s?.drinkTagIds ?? [],
  }
}

export const draftSelectedScenes$ = atom((get) => {
  return countSelectedTags(scenes, get(draftTagIds$).sceneTagIds)
})
draftSelectedScenes$.debugLabel = 'draftSelectedScenes$'

export const draftSelectedFoods$ = atom((get) => {
  return countSelectedTags(foods, get(draftTagIds$).foodTagIds)
})
draftSelectedFoods$.debugLabel = 'draftSelectedFoods$'

function countSelectedTags(categories: TagCategory[], tagIds: RestaurantTagId[]): number {
  const set = new Set(tagIds)
  return categories
    .flatMap((scene) => scene.children)
    .filter((tag) => {
      const tagId = tag.facetKey.split('.').at(-1) as RestaurantTagId
      return set.has(tagId)
    }).length
}
